import { GetItemFromStorage, SetItemInStorage } from "../../../custom_hooks/useStorage";
import { getDataFromLocalStorage, setDataInLocalStorage } from "../../../utils/storage";

import { Cookies } from "../../../utils/cookies";
import { LocalStorage } from "../../../custom_hooks/localStorageKeys";
import { LocalStorageKey } from "../../../constants/local_storage_keys";
import { ParseJWT } from "../../../services/jwt_parser";
import { USER_INFORMATION } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { initialUserSetup } from "../../api/user_information";

const initialState = {
  isLoading: true,
  email: "",
  token: "",
  userInformation: {} as any,
  error: {
    hasError: false,
    errorMessage: "",
  },
};
const userInformationSlice: any = createSlice({
  name: USER_INFORMATION,
  initialState,
  reducers: {
    updateUserInformation: (state, { payload }) => {
      const userInformation = { ...state.userInformation, payload };
      state.userInformation = userInformation;
    },
    initializeUserState: (state) => {
      // const cookieData: any = Cookies.get();
      const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
      const userEmail = GetItemFromStorage(LocalStorage.USER_EMAIL);
      state.email = userEmail;
      state.token = accessToken;
      const parsedJsonData = ParseJWT(accessToken);
      SetItemInStorage(LocalStorage.ROLE_ID, parsedJsonData.ccaas_role_id);
      SetItemInStorage(LocalStorage.USER_DETAILS, parsedJsonData);
      // Cookies.set("role_id", parsedJsonData.ccaas_role_id, 1);
      // Cookies.set("user_details", JSON.stringify(parsedJsonData), 365);
      state.userInformation = parsedJsonData;
      setDataInLocalStorage(LocalStorageKey.USER_DATA, {
        email: state.email,
        token: state.token,
        userInfo: state.userInformation,
      });
    },
    retrieveUserState: (state) => {
      // const cookieData: any = Cookies.get();
      const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
      const userEmail = GetItemFromStorage(LocalStorage.USER_EMAIL);
      state.email = userEmail;
      state.token = accessToken;
      state.userInformation = ParseJWT(accessToken);
      if (!state.email || !state.token || !state.userInformation.hasOwnProperty("uuid")) {
        const data = getDataFromLocalStorage(LocalStorageKey.USER_DATA);
        if (data) {
          state.email = data.email;
          state.token = data.token;
          state.userInformation = data.userInfo;
        }
      }
    },
    reset: () => {},
  },
  extraReducers: (builder) => {
    builder.addCase(initialUserSetup.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(initialUserSetup.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        const responseData = payload.data.result;
        const updatedUserInformation = {
          initial_selection_flag: responseData.initial_selection_flag,
          is_first_time: responseData.is_first_time,
          initial_setup_menu: responseData.initial_setup_menu,
          initial_setup_flag: responseData?.initial_setup_flag ?? "0",
          uid: responseData.uid,
          roleId: responseData.ccas_role_info,
        };
        const userInformation = state.userInformation;
        state.userInformation = { ...userInformation, updatedUserInformation };
      } else {
        state.error.hasError = true;
        state.error.errorMessage = payload?.data?.message;
      }
      state.isLoading = false;
    });
    builder.addCase(initialUserSetup.rejected, (state, { payload }: any) => {
      state.error.hasError = true;
      state.error.errorMessage = payload?.data?.message;
      state.isLoading = false;
    });
  },
});
export const UserInformationActions = userInformationSlice.actions;
export default userInformationSlice.reducer;
